import { t } from 'i18next';
import { RAID_METADATA_BY_SLUG } from '../../../../../shared/enums';
import RaidRankingsLoader from '../raidRankingsLoader';
import { CountdownPane } from './countdownPane';
import { RaidRankingsContentFrontpage } from './raidRankingsContentFrontpage';
import { RecentRaidRankingsContentFrontpage } from './recentRaidRankingsContentFrontpage';
import moment from 'moment';
import apiService from '../../../services/apiService';
import { createActionGetRaidRankings } from '../../../actions/getRaidRankings';
import _ from 'lodash';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';

export type TRaidDuoPaneProps = {
  enabled: boolean;
  raidSlug: string;
  seasonSlug: string;
  difficulty: string;
  region: string;
  realm?: string;
  overrideImageSlug?: string;
  isSecondary?: string;
};

export function RaidDuoPane(props: TRaidDuoPaneProps) {
  if (!props.enabled) {
    return null;
  }

  const isRaidOpen = moment.utc() >= RAID_METADATA_BY_SLUG[props.raidSlug].starts.us;

  return (
    <>
      <h2 className="slds-m-bottom--small slds-m-top--large rio-m-top-mobi--small">
        <span className="rio-text-title--caps text-raiderio">
          {t('frontpage:section-header-raid-progress', {
            raid: t(`raids:${props.raidSlug}.name`)
          })}
        </span>
        <span className="slds-m-left--small slds-text-title--caps text-white">
          {t('frontpage:difficulty-raid-progress', {
            difficulty: t(`common:difficulty.${props.difficulty}.name`)
          })}{' '}
          ({t(`seasons:${props.seasonSlug}.base-name`)})
        </span>
      </h2>

      {isRaidOpen ? (
        <Row gutter={['xxx-small', 'xx-small']}>
          {[RAID_METADATA_BY_SLUG[props.raidSlug]].map((r) => (
            <Col xs={12} md={6} key={r.slug} className={'slds-is-relative'}>
              <RaidRankingsLoader
                component={RaidRankingsContentFrontpage}
                limit={5}
                title={t('frontpage:top-guilds')}
                raid={r.slug}
                difficulty={props.difficulty}
                region={props.region}
                realm={props.realm || 'all'}
                instanceId={`frontpage:raid:top:${props.region}:${props.realm || 'all'}:${r.slug}${props.isSecondary ? ':isSecondary' : ''}`}
                ignoreErrors={true}
                controlledDifficulty={true}
              />
            </Col>
          ))}

          {[RAID_METADATA_BY_SLUG[props.raidSlug]].map((r) => (
            <Col xs={12} md={6} key={r.slug} className={'slds-is-relative'}>
              <RaidRankingsLoader
                component={RecentRaidRankingsContentFrontpage}
                limit={5}
                title={t('frontpage:recent-progress')}
                raid={r.slug}
                difficulty={props.difficulty}
                region={props.region}
                realm={props.realm || 'all'}
                instanceId={`frontpage:raid:recent:${props.region}:${props.realm || 'all'}:${r.slug}${props.isSecondary ? ':isSecondary' : ''}`}
                recent={true}
                ignoreErrors={true}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <CountdownPane
          bgImagePath={`/images/${props.overrideImageSlug || props.raidSlug}/headers/_zone.jpg`}
          locString="frontpage:raid-unlocks-in"
          targetDate={RAID_METADATA_BY_SLUG[props.raidSlug].starts.us.format()}
        />
      )}
    </>
  );
}

(RaidDuoPane as any).preloadComponentActions = async (props: TRaidDuoPaneProps, params: any) => {
  if (!props.enabled) {
    return [];
  }

  const promises = [];

  promises.push(
    new Promise((resolve, reject) => {
      const loadParams: any = {
        raid: props.raidSlug,
        difficulty: props.difficulty,
        region: props.region,
        realm: props.realm || 'all',
        limit: 5,
        faction: '',
        page: 0,
        recent: false
      };

      apiService.getRaidInstanceRankings(loadParams, (err, data: any) => {
        if (err) {
          reject(err);
        } else {
          resolve([
            createActionGetRaidRankings(
              `frontpage:raid:top:${props.region}:${loadParams.realm}:${props.raidSlug}`,
              data.raidRankings
            )
          ]);
        }
      });
    })
  );

  promises.push(
    new Promise((resolve, reject) => {
      const loadParams: any = {
        raid: props.raidSlug,
        difficulty: props.difficulty,
        region: props.region,
        realm: props.realm || 'all',
        limit: 5,
        faction: '',
        page: 0,
        recent: true
      };

      apiService.getRaidInstanceRankings(loadParams, (err, data: any) => {
        if (err) {
          reject(err);
        } else {
          resolve([
            createActionGetRaidRankings(
              `frontpage:raid:recent:${props.region}:${loadParams.realm}:${props.raidSlug}`,
              data.raidRankings
            )
          ]);
        }
      });
    })
  );

  return _.flatten(await Promise.all(promises));
};
